






























































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import ScriptSentence from "@/views/playbooks/ScriptSentence.vue";
import { emptyFn } from "@/fp";
import {
  ApplicationType,
  ScanSession,
} from "@/views/customize/data-sources/data/model";
import { state } from "@/views/playbooks/data/state";
import HeaderSection from "./HeaderSection.vue";
import { cloud_playbooks_state } from "../data/state";
import DataInstances from "./DataInstances.vue";
import SessionsDropdown from "./SessionsDropdown.vue";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { FindingType } from "@/common/api/findings/findings.model";
import { PlaybookDataDescriptor } from "../data/model";
import RunScriptModalVue from "./RunScriptModal.vue";
import ViewResultsModalVue from "./ViewResultsModal.vue";

/*
 TODO: make key from each instance (sessionId,appId,finding_type,label_id) {[key]:true}
 than for each change in the vars & session_id
 I need to run a check to see if such a key already exist

 each time a new instance is created! I need to add it's key to the instances_keys_map.
*/

export default Vue.extend({
  components: {
    Modal,
    ScriptSentence,
    HeaderSection,
    DataInstances,
    SessionsDropdown,
  },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "105rem",
      height: "80rem",
      withTopRightCloseBtn: true,
    };

    const { template_vars } = state;
    //@ts-ignore
    const playbook_id: string = props.modalData!.id;
    const {
      data_instances,
      is_loading_instances,
      playbook,
      download_data,
      stop_running_or_building,
      upload_data,
      generate_data,
      do_we_have_an_instance_with_the_same_props,
      instances_keys_map,
      source_applications,
      available_sessions,
      is_loading_sessions,
      selected_session,
      set_selected_session: _set_selected_session,
      on_sessions_ready,
      run_cloud_script_against_data_instance,
      destroy,
      init,
      load_instances,
      load_instances_from_vars,
    } = cloud_playbooks_state.use_playbook(playbook_id);

    const script_vars_el: Ref<{
      get_vars: () => Record<string, string>;
      set_vars: (vars: Record<string, string>) => void;
    } | null> = ref(null);

    const has_zero_sessions = computed(
      () => available_sessions.value.length == 0 && !is_loading_sessions.value
    );

    const has_session_params = computed(() => {
      if (selected_session.value) {
        const source = data_sources_state.all_sources.value.find(
          (d) => d.id == selected_session.value!.service
        )!;
        return source.startParams.length > 0;
      } else {
        return false;
      }
    });

    const instance_with_same_props = ref({ has: false, index: -1 });
    const check_for_same_instance_props = () => {
      const vals = script_vars_el.value && script_vars_el.value.get_vars();
      // @ts-ignore
      const app: ApplicationType = vals["{~application}"];
      // @ts-ignore
      const finding_type: FindingType = vals["{~finding_type}"];
      // @ts-ignore
      const label: string = vals["{~label}"];
      instance_with_same_props.value = do_we_have_an_instance_with_the_same_props(
        {
          app_id: app,
          finding_type,
          label_id: label,
          service_id: playbook.criteria.serviceId,
          session_id: +selected_session.value!.id || -1,
        }
      );
    };
    const on_var_change = () => {
      check_for_same_instance_props();
      load_instances_from_vars(
        selected_session.value!.id,
        script_vars_el.value?.get_vars()
      );
    };

    const set_selected_session = (session: any) => {
      _set_selected_session(session);
      check_for_same_instance_props();
      load_instances_from_vars(session.id, script_vars_el.value?.get_vars());
    };

    const files: Ref<{
      file_name: string;
      download_fn: () => void;
    }[]> = ref([]);

    const csv_file_to_upload: Ref<File | null> = ref(null);
    const on_file_uploaded = (files: File[] = []) => {
      console.log("on_file_uploaded : ", files);
      if (files.length > 0) {
        csv_file_to_upload.value = files[0];
      }
    };

    const create_the_data = async () => {
      if (script_vars_el.value) {
        const vals = script_vars_el.value.get_vars();
        // @ts-ignore
        const app: ApplicationType = vals["{~application}"];
        // @ts-ignore
        const finding_type: FindingType = vals["{~finding_type}"];
        // @ts-ignore
        const label: string = vals["{~label}"];
        console.log("vals", vals);
        // @ts-ignore
        await generate_data(app, finding_type, label);
      }
    };

    const on_instance_action = async (payload: {
      action: string;
      instance: PlaybookDataDescriptor;
    }) => {
      const { action, instance } = payload;
      console.log(payload);
      switch (action) {
        case "download":
          await download_data(instance);
          break;
        case "run":
          const res = await UseModal().show(RunScriptModalVue, {
            playbook,
            instance,
          });
          if (res.type === "success") {
            await run_cloud_script_against_data_instance(instance);
          }
          break;
        case "cancel_running":
        case "cancel_data_collecting":
          await stop_running_or_building(instance);
          break;
        case "view_results":
          await UseModal().show(ViewResultsModalVue, {
            instance,
            playbook,
          });

          break;
        default:
          console.log("nothing");
          break;
      }
    };

    const disable_generate_btn = computed(() => {
      return (
        instance_with_same_props.value.has ||
        has_zero_sessions.value ||
        selected_session.value?.status != "Closed"
      );
    });

    const subs = {
      gen_script_listener: emptyFn(),
    };

    const cloud_template_vars = ref({});

    onMounted(() => {
      const { vars, session, id } = props.modalData as {
        // script id
        id: string;
        application?: ApplicationType;
        session?: ScanSession & {
          name: string;
        };
        // script template variants (optional)
        vars?: Record<string, string>;
      };

      if (session) {
        on_sessions_ready(() => {
          // @ts-ignore
          set_selected_session(session);
        });
      }
      if (!vars) {
        on_sessions_ready(() => {
          console.log("session when opened:", session);
          load_instances({
            playbook_id: id,
            filters: {
              findingSessionId: selected_session.value?.id,
            },
          });
        });
      }

      init();

      cloud_template_vars.value = {
        ...template_vars.value,
        "{~application}": source_applications.value.map(({ id, name }) => ({
          id,
          name,
        })),
        "{~finding_type}": playbook.criteria.findingTypes.map((id) => ({
          id,
          name: id,
        })),
      };

      if (vars) {
        // wait for the SentenceEl to mount and
        // then set the vars
        load_instances_from_vars(session?.id || "", vars);
        const unsub = watch(script_vars_el, (new_val) => {
          if (new_val) {
            new_val.set_vars(vars);
            unsub();
          }
        });
      }
    });

    onBeforeUnmount(() => {
      destroy();
      Object.values(subs).forEach((unsub) => unsub());
    });

    return {
      cloud_template_vars,
      script_vars_el,
      has_zero_sessions,
      on_var_change,
      instance_with_same_props,
      instances_keys_map,
      config,
      playbook,
      stop_running_or_building,
      upload_data,
      is_loading_instances,
      data_instances,
      files,
      on_file_uploaded,
      csv_file_to_upload,
      create_the_data,
      disable_generate_btn,
      has_session_params,
      // sessions
      available_sessions,
      is_loading_sessions,
      selected_session,
      set_selected_session,
      on_instance_action,
    };
  },
});
